import { ChangeEvent, useContext, useState } from "react";
import departements from '../../../../../../assets/json/departements-region.json';
import { ReactComponent as TuneIcon } from '../../../../../../assets/vectors/tune.svg';
import { SearchCompaniesOnMapContext } from "../SearchCompaniesOnMap.context";
import { useAddressCoordinatesAutocomplete } from "../../../../../../hooks/fetchers/useAddressCoordinatesAutocomplete/useAddressCoordinatesAutocomplete";
import { AddressCoordinatesFeature, AddressTypes } from "../../../../../../types/models/address/address.types";
import AddressCoordinatesInput from "../../../../../commons/AddressCoordinatesInput/AddressCoordinatesInput";
import Button from "../../../../../designSystem/Button/Button";

export default () => {
  
  const { 
    setFilters, 
    setDomainsFilterModalOpen, 
    setCurrentLocation 
  } = useContext(SearchCompaniesOnMapContext)

  const [searchInputValue, setSearchInputValue] = useState<string>('');

  const { data: addressSuggestions } = useAddressCoordinatesAutocomplete(searchInputValue);

  const onAddressChange = (
    e: ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;
    setSearchInputValue(value);
  };

  const handleSelectedSuggestion = (suggestion: AddressCoordinatesFeature) => {
    setSearchInputValue(suggestion.place_name)
    const num_departement = suggestion.context?.find((item) => item.id.includes('region'))?.short_code?.replace('FR-', '')
    const city = suggestion.context?.find((item) => item.id.includes('place'))?.text
    const department = departements.find((res) => res.num_dep.toString() == num_departement)?.dep_name
    const region = (suggestion.place_type[0] as AddressTypes) === AddressTypes.Region
      ? suggestion.text
      : departements.find((res) => res.num_dep.toString() == num_departement)?.region_name
    const [longitude, latitude] = suggestion.center
    setCurrentLocation({
      latitude,
      longitude,
      city,
      department,
      region: region as string,
      type: suggestion.place_type[0] as AddressTypes
    })
    setFilters((value) => ({
      ...value,
      department,
      region
    }))
  };

  return (
    <div className='dashboard-companies__header-container'>
      <div className="dashboard-companies__header">
        <AddressCoordinatesInput
          features={addressSuggestions}
          placeholder="Tapez une adresse..."
          value={searchInputValue}
          onChange={(e) => onAddressChange(e)}
          handleSelectedSuggestion={handleSelectedSuggestion}
        />
        <Button
          startIcon={TuneIcon}
          startIconProps={{
            style: {
              position: 'unset'
            }
          }}
          onClick={() => setDomainsFilterModalOpen(true)}
        >
          {''}
          {/* {filters.fieldsOfActivity.length > 0
          ? `Filtrer (${filters.fieldsOfActivity.length})`
          : ''} */}
        </Button>
      </div>
    </div>
    )

}